import { render, staticRenderFns } from "./TicketRefreshment.vue?vue&type=template&id=6383e8e7&"
import script from "./TicketRefreshment.vue?vue&type=script&lang=js&"
export * from "./TicketRefreshment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TicketRefreshment.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VDataTable,
  VFlex,
  VLayout,
  VTextField,
})
